import RestService from '../services/rest';

async function getListPower(powerRangeId, limit, skip, search, orderBy, field) {
  return RestService.getAuthenticated(
    `panel/power/list?powerRangeId=${powerRangeId}&limit=${limit}&skip=${skip}&search=${search}&orderBy=${orderBy}&field=${field}`,
  );
}

async function getOptionsPower(search) {
  return RestService.getAuthenticated(
    `panel/power/options?search=${search}`,
  );
}

async function createPower(newPower) {
  return RestService.postAuthenticated(
    'panel/power/create', newPower,
  );
}

async function updatePower(updPower) {
  return RestService.putAuthenticated(
    'panel/power/update', updPower,
  );
}

export default {
  getListPower,
  getOptionsPower,
  createPower,
  updatePower,
};
